import React from 'react';
import { Button, Tooltip } from '@material-ui/core';

import { UserAvatar } from 'src/components/UserAvatar';

export const ProfileButton = ({ onClick, name, email, planLabel }) => {
  return (
    <Tooltip
      disableFocusListener
      title={
        <div className="flex flex-col gap-[4px] text-xs">
          <span className="font-bold">{name}</span>
          <span>{email}</span>
          <span>Current plan: {planLabel}</span>
        </div>
      }
    >
      {/* 
        HINT: we want to allow user to logout or change customer if "Churnkey Pause Wall" is displayed,
              therefore "z-index: 41" is used to display ProfileButton on top of "Churnkey Pause Wall" overlay("z-index: 40")
      */}
      <Button
        className="min-w-0 h-auto p-0 z-[41]"
        onClick={onClick}
        data-testid="ProfileButton"
        data-onboarding="ProfileButton"
      >
        <UserAvatar
          name={name}
          className="w-4 h-4 text-base"
        />
      </Button>
    </Tooltip>
  );
};
